<div class="loading-shade" *ngIf="isLoading ">
	<mat-spinner diameter="80" *ngIf="isLoading"></mat-spinner>
</div>
<form [formGroup]="editSchoolsForm" class="formEditSchool" >
	<span class="forceFloatRight"><button mat-icon-button color="primary" (click)="closeRecord()">
			<span><mat-icon style="transform:translateX(-3px);">close</mat-icon></span>
		</button></span> <!-- <i class="fa-edit"></i> -->
		<mat-card-title><span style="padding-left:18px;font-size:larger;">Edit School </span></mat-card-title>
	<p><span class="schoolFont schoolFontDrop" style="padding-left:18px;">{{schoolName}}</span>&nbsp;&nbsp;<span class="posRel">
		<ng-container *ngIf="!bCancelEdit"><button
				mat-raised-button matTooltipschool="Edit record" (click)="fnEdit()" class="btnRaise" style="padding: 5px;">				
				&nbsp;{{editBtnText}}<mat-icon class="iconDisplay">edit</mat-icon>				
			</button> 
		</ng-container>
		<ng-container *ngIf="bCancelEdit"><button mat-raised-button matTooltip="Cancel edit"
					(click)="fnCancelEdit()" class="btnRaise">
					<mat-icon class="iconDisplay">close</mat-icon>
					&nbsp;&nbsp;{{editBtnText}}
			</button></ng-container>
		</span></p>

	<mat-tab-group #tabGroup (selectedTabChange)="fnSetSaveButton($event)">
		<mat-tab label="General Info">
			<div class="row">
				<div class="child-1 col-6 halfWidth">
					<mat-card appearance="outlined" class="cardGeneral">
						<mat-card-content>
							<h2>General</h2>
							<div class="form-group">
								<div class="row">
									<mat-form-field class="field-full-width" appearance="fill" tabindex="0">
										<mat-label>School Name *</mat-label>
										<input id="schoolName" 
											[readonly]="isUneditable" 
											formControlName="schoolNameFC"
											type="text" matInput 
											maxlength="100"
											(keydown)="onKeyDownText($event)"                 
											(keyup)="onKeyUp($event)"	
											class="form-control"
											[(ngModel)]="schoolName" 
											placeholder="School Name"
											>																					
									</mat-form-field>
								</div>
								<div class="row">
									<mat-form-field class="field-full-width" appearance="fill" tabindex="1">
										<mat-label>SSID</mat-label>
										<input id="schoolSSID" 
											[readonly]="isUneditable" 
											formControlName="schoolSSID"
											type="text" matInput 
											maxlength="256" 
											class="form-control" 
											[(ngModel)]="SSID"
											placeholder="SSID">
									</mat-form-field>
								</div>
								<div class="row">
									<mat-form-field class="field-full-width" appearance="fill" tabindex="2">
										<mat-label>CDS Code</mat-label>
										<input id="cdsCode" [readonly]="true" formControlName="cdsCode"
											type="text"  matInput maxlength="14" class="form-control"
											(keydown)="onKeyDown($event)"                 
											(keyup)="onKeyUp($event)"											  
											placeholder="CDS Code" [(ngModel)]="CDSCode">
									</mat-form-field>
								</div>
								<div class="row">
									<mat-label>School NCES 
										<help-text-btn class="align-help-text-btn" [helpTextId]="'SchoolNCES'"></help-text-btn>
									</mat-label>
								</div>
								<div class="row">
									<mat-form-field class="field-full-width" appearance="fill" tabindex="3">
										<input id="schoolNCES" [readonly]="isUneditable" formControlName="schoolNCES"
											type="number"matInput maxlength="256" class="form-control"
											(keydown)="onKeyDown($event)"                 
											(keyup)="onKeyUp($event)"		
											[(ngModel)]="NCES">
									</mat-form-field>

								</div>

							</div>
						</mat-card-content>
					</mat-card>
				</div>
				<div class="child-2 col-6 halfWidth">
					<mat-card appearance="outlined" class="cardSchoolType">
						<mat-card-content>

							<h2>School Type</h2>
							<div class="form-group">
								<div class="row">
									<div class="col-6">
										<!--											
											schoolType {{schoolType}}									
										
												iToggleSCValid1 {{iToggleSCValid1}}
											bCheckedSCCode1 {{bCheckedSCCode1}}
											
											iToggleSCValid2 {{iToggleSCValid2}}
											bCheckedSCCode2 {{bCheckedSCCode2}}
											
											iToggleSCValid3 {{iToggleSCValid3}}
											bCheckedSCCode3 {{bCheckedSCCode3}}
											bAllowSC {{this.bAllowSC}}
											isUneditable {{isUneditable}}
											(isUneditable && bAllowSC){{(isUneditable && bAllowSC)}}  
											bDisAllowSubTypes {{bDisAllowSubTypes}}-->								
										<mat-radio-group name="radioSchoolTypeList" id="radioSchoolType"
											[disabled]="isUneditable" class="form-control" value="1"
											formControlName="radioSchoolType" aria-label="Select an option">
											<mat-radio-button *ngFor="let op of radioOptionsSchoolType" name="opList"										
												[checked]="((op.id == 1) && bCheckedSCCode1) || ((op.id == 2) && bCheckedSCCode2) || ((op.id == 3) && bCheckedSCCode3)"
												(click)="fnFigureRadioSchoolChecked($event, op.id, schoolType)"
												value="{{op.id}}">{{ op.name}}&nbsp;</mat-radio-button>											
										</mat-radio-group>					
									</div>
									<p>&nbsp;</p>
								</div>
								<div class="row">
									<mat-form-field appearance="fill">
										<mat-label>- Choose Other Sub-type -</mat-label>														
										<mat-select id="selectSubType" [disabled]="isUneditable" [(ngModel)]="selectedSubTypeItem" value="selectedSubTypeItem"
											[disabled]="isUneditable || bDisAllowSubTypes" formControlName="selectSubType"
											(ngModelChange)="showValuePromptText('SubTypeItem', $event)"
											[errorStateMatcher]="matcher" >
											<mat-option *ngFor="let subTypeItem of subTypeItems"
												[value]="subTypeItem?.ID">{{subTypeItem?.TYPE}}</mat-option>

										</mat-select>
										<!--  <mat-error *ngIf="selected.hasError('required')">You must make a
                                            selection
                                        </mat-error>
                                        <mat-error
                                            *ngIf="selected.hasError('pattern') && !selected.hasError('required')">
                                            Your selection is invalid
                                        </mat-error>-->
									</mat-form-field>
								</div>
								<div class="row">
									<mat-label>School Code</mat-label>
								</div>
								<div class="row">
									<!--
										number
									isUneditable {{isUneditable}}
                                    scValid {{scValid}} : ngChecking {{ngChecking}} : ngValid {{ngValid}} : ngChecked {{ngChecked}}    -->
									<mat-form-field appearance="fill">
										<input id="txtSchoolCode" type="text" [disabled]="(!bAllowSC)"
											(click)="btnClick2.emit($event)"
											[readonly]="(!bAllowSC)" formControlName="txtSchoolCode"
											(keydown)="onKeyDown($event)"                 
											(keyup)="onKeyUp($event)"											  
											[formControl]="selected" (keyup)="checkSchoolCode($event)"
											[(ngModel)]="schoolCode" matInput><!-- pattern="[0-9]" -->
										<span class="schoolCodePos" style="position:absolute;right:33px;">
											<ng-container *ngIf="!scValid && ngChecking">
												<!-- including if sc is blank or invalid-->
												<button class="btnCheckRed" mat-raised-button [disabled]="isUneditable"
													(click)="btnClick.emit($event)">
													<i class="fa fa-refresh fa-spin fa-fw"></i>
												</button>
											</ng-container>
											<ng-container *ngIf="!scValid && !ngChecking && ngValid && !ngChecked">
												<span style="position:absolute;padding-right:30px;"><button class="btnCheckRed" mat-raised-button [disabled]="isUneditable"
													(click)="btnClick.emit($event)">
													<i class="fa fa-check fa-fw fa-times" style="opacity:0.3"></i>
													<!-- &emsp;<mat-icon matSuffix>highlight_off</mat-icon> &emsp; -->
												</button></span>
											</ng-container>
											<ng-container *ngIf="!scValid && !ngChecking && ngValid && ngChecked">
												<button class="btnCheckGreen" mat-raised-button [disabled]="isUneditable"
													(click)="btnClick.emit($event)">
													<i class="fa fa-check fa-fw"></i>
													<!-- testme
													<mat-icon matSuffix>highlight_off</mat-icon> -->
												</button>
											</ng-container>
											<ng-container *ngIf="!scValid && !ngChecking && !ngValid" && ngChecked><!--  && !ngChecked-->
												<span style="position:absolute;padding-right:20px;">
													<button class="btnCheckRed" mat-raised-button [disabled]="isUneditable"
													(click)="btnClick.emit($event)">
													<i class="fa fa-check fa-fw fa-times" style="opacity:0.3"></i>
												<!-- 	<mat-icon matSuffix>highlight_off</mat-icon> -->
												</button></span>
											</ng-container>
											<ng-container *ngIf="scValid">
												<button class="btnCheckGreen" mat-raised-button
													[disabled]="isUneditable" (click)="btnClick.emit($event)">
													<i class="fa fa-check fa-fw"></i>
													<!--<mat-icon matSuffix>highlight_off</mat-icon>
													 <mat-icon matSuffix>check_circle</mat-icon> -->
												</button>
											</ng-container>
										</span>
										<!-- <button class="btnCheckRed" mat-raised-button>                                                
                                                <mat-icon matSuffix>check_circle_outline</mat-icon>
                                            </button>  
                                            -->
										<!--  check_circle     check_circle_outlne -->

									</mat-form-field>
									<div *ngIf="!isUneditable">
										<mat-error *ngIf="selected.hasError('required')">Please enter a valid School
											Code.
										</mat-error>
									</div>

								</div>
								<div class="row">
									<mat-checkbox [color]="'primary'" id="chkSatelliteCampus" [checked]="satelliteCampus"
										[disabled]="isUneditable"
										(change)="valueChkChange($event)"
										>Satellite Campus</mat-checkbox>
								</div>
							</div>

						</mat-card-content>
					</mat-card>
				</div>
			</div>
			<div class="row">
				&nbsp;
			</div>
			<div class="row">
				<div class="child-3 col-6 halfWidth">
					<mat-card appearance="outlined" class="cardSchoolStatus">
						<mat-card-content>
							<H2>School Status</H2>
						<!-- 	school status {{schoolStatus}}
							{{(bCheckedSCCode1)}}
							{{(bCheckedSCCode2)}}
							{{(bCheckedSCCode3)}}  formControlName="radioSchoolStatus1"  -->
							<div class="form-group"> 
								<div class="row">
									<div class="col-6 halfWidthExact">										
										<mat-radio-group name="radioSchoolStatusList" id="radioSchoolStatus" 
										 class="form-control" [disabled]="isUneditable"
										aria-label="Select an option" >										
											<mat-radio-button *ngFor="let op2 of radioOptionsSchoolStatus" name="opList2"																																		
												(click)="fnFigureRadioSchoolStatusChecked($event, op2.id)"	
												[checked]="(op2.id == schoolStatus)"
												[readonly]="isUneditable"
												[disabled]="isUneditable"
												value="{{op2.id}}"
												>{{op2.name}}&nbsp;&nbsp;
											</mat-radio-button><!-- value="1" [checked]="true"  tabindex="4" value="{{op2.id}}"  (op2.id == 1) || (op2.id == 2) || (op2.id == 3) [checked]="(op.id == schoolStatus)"-->
										<!--"(op2.id == schoolStatus)"        
											((op2.id == schoolStatus) && bCheckedSCCode1) || ((op2.id == schoolStatus) && bCheckedSCCode2) || ((op2.id == schoolStatus) && bCheckedSCCode3) 	"  -->
									</mat-radio-group>
									</div>
									<div class="col-6 halfWidthIncrease">
										<div class="raiseUpCloseDate form-group">
											<!--	bCancelEdit {{bCancelEdit}}										
												isUneditable {{isUneditable}}
												schoolStatus {{schoolStatus}} -->
											Close Date&nbsp;									
											<mat-form-field class="schoolDatePicker" style="height:90px;"  appearance="fill" color="accent">
												<!--<mat-label>Close Date</mat-label> -->
												<div *ngIf="isUneditable">																		
													<span class="raiseDownSmall"><input matInput 
													 formControlName="frmCloseDate" 
														[matDatepicker]="picker" 
														readonly
														(ngModelChange)="recheckClosedDate($event)"
														placeholder="{{closedDate ? (closedDate | date:'MM/dd/yyyy') : ''}}"
														(dateInput)="addEvent('input', $event)"
														(dateChange)="addEvent('change', $event)"
														></span> <!-- [formControl]="newTestDate"
														-->
													 <mat-datepicker style="background-color:transparent;" #picker disabled></mat-datepicker> 												
												</div> <!-- 	placeholder="{{closedDate? (closedDate!|simpleDate) : '' }}"-->
											 	<div *ngIf="!isUneditable && (schoolStatus == 2)">	 																										
													<span style="position:absolute;float:right;top:21px;right:0px;"><!-- position:absolute; top:20px;right:0px;-->
														<button class="noBordersBtn" (click)="openDialog()" style="background-color:transparent;"><mat-icon>calendar_today</mat-icon></button></span>                                                     
														<input matInput 													
														placeholder="{{closedDate ? (closedDate | date:'MM/dd/yyyy') : ''}}"
														readonly
														(ngModelChange)="recheckClosedDate($event)"
														formControlName="frmCloseDate"																			
														style="transform:translateY(7px);width:130px;"><!-- <span class="raiseDownSmall"></span><span style="transform:translateY(-17px);"class="raiseDownSmall"></span>-->
												</div> 												
												<div *ngIf="!isUneditable && (schoolStatus != 2)">													
													<span style="position:absolute;float:right;top:21px;right:0px;"><!-- position:absolute;top:20px;right:0px;-->
														<button class="noBordersBtn" disabled=true (click)="openDialog()" style="background-color:transparent;"><mat-icon>calendar_today</mat-icon></button></span> 
														<input matInput 													
														placeholder="{{closedDate ? (closedDate | date:'MM/dd/yyyy') : ''}}"
														readonly
														(ngModelChange)="recheckClosedDate($event)"
														formControlName="frmCloseDate"			
														style="transform:translateY(7px);width:130px;"	
														><!--<span class="raiseDownSmall"></span> style="transform:translateY(-17px);" 	-->									
												</div> 
											</mat-form-field>	 
											<br><span class="errorMsgCtl">{{myCloseDateError}}</span>										
										</div>
									</div>									
								</div>
							</div>
						</mat-card-content>
					</mat-card>
				</div>
				<div class="child-4 col-6 halfWidth">
					<mat-card appearance="outlined" class="cardGradeSpan">
						<mat-card-content>
							<h2>Grade Span and Period</h2>
							<div class="form-group">
								<div class="row">
									<div class="col-6">
										<mat-form-field appearance="fill">
											<mat-label>- Select Low Grade -</mat-label>
											<mat-select id="selectLowGrade" [(ngModel)]="gradeSpanLow" value="gradeSpanLow"
												formControlName="selectLowGrade"
												[disabled]="isUneditable"			
												(ngModelChange)="showValuePromptText('LowGradeItem', $event)"																			
												 [errorStateMatcher]="matcher"												 											
												 >											
												<mat-option *ngFor="let lowGradeItem of gradeItems"
													[value]="lowGradeItem?.ID">{{lowGradeItem.GRADES}}
													({{lowGradeItem?.DESCRIPTION}})</mat-option>
											</mat-select>
											<!--<mat-error *ngIf="selected.hasError('required')">You must make a selection
											</mat-error> -->
											<mat-error *ngIf="!validGrades">
												Low grade cannot be greater than high grade.
											</mat-error>
										</mat-form-field>
									</div>
									<div class="col-6">
										<mat-form-field appearance="fill">
											<mat-label>- Select High Grade -</mat-label>
											<mat-select id="selectHighGrade" [(ngModel)]="gradeSpanHigh" value="gradeSpanHigh"
												formControlName="selectHighGrade"
												[disabled]="isUneditable"		
												(ngModelChange)="showValuePromptText('HighGradeItem', $event)"																					
												 [errorStateMatcher]="matcher"													 											 
											 >											 
												<mat-option *ngFor="let highGradeItems of gradeItems"
													[value]="highGradeItems?.ID">{{highGradeItems.GRADES}}
													({{highGradeItems?.DESCRIPTION}})</mat-option>
											</mat-select><!--	[formControl]="selected"-->
											<!-- <mat-error *ngIf="selected.hasError('required')">You must make a selection
											</mat-error> -->										
											<mat-error *ngIf="!validGrades">
												Low grade cannot be greater than high grade.
											</mat-error>
										</mat-form-field>
									</div>
									<span class="errorMsgCtl">{{myGradeError}}</span>
								</div>
							</div>
						</mat-card-content>
					</mat-card>
				</div>
			</div>
		</mat-tab>
		<mat-tab label="Contact Info">
			<div class="addPadding">
				<ng-container *ngIf="isUneditable">
					<view-party-contact-mechanism *ngIf="(partyIdNum > 0)" [partyId]="partyIdNum"
						[enabledTypes]="['contactPersons','postalAddresses', 'emails','phoneNumbers']"
						[filterAddressTypes]="['Work Address']"
						[filterPhoneNumberTypes]="['Home Phone', 'Cell Phone', 'Work Phone', 'Other Phone']"
						[removeAddressTypes]="['Birthplace Address']"></view-party-contact-mechanism>
				</ng-container>
				<ng-container *ngIf="!isUneditable">
					<edit-party-contact-mechanism *ngIf="(partyIdNum > 0)" [partyId]="partyIdNum"
						[enabledTypes]="['contactPersons','postalAddresses', 'emails','phoneNumbers']"
						[filterAddressTypes]="['Current Address', 'Mailing Address']"
						[filterPhoneNumberTypes]="['Home Phone', 'Cell Phone', 'Work Phone', 'Other Phone']"
						[removeAddressTypes]="['Birthplace Address']"
						(isEditingChange)="fnIsEditingContactMechChange($event)"
						(partyContactMechanismsChange)="fnPartyEditingContactMechChange($event)"
						[type]="'Organization'"
						></edit-party-contact-mechanism>
				</ng-container>
			</div>
		</mat-tab>
		<mat-tab label="School Location">
			<div class="row">
				<region-dropdown-two-way id="myRegion" [(selectedRegions)]="chosenRegions" (selectedRegionsChange)="regionEventEmitter($event)" [reset]="resetField"
					[isMultiple]="false" [customLabel]="customRegionLabel" [disabled]="isUneditable" [allowAllRegions]="true" #child2></region-dropdown-two-way>
			</div>
			<div class="row">
				<county-dropdown-two-way id="myCounty1" [reset]="resetField" [(selectedCounties)]="chosenCounties" [regions]="chosenRegions" (selectedCountiesChange)="countiesSelected($event)"
					[isMultiple]="false" [customLabel]="customCountyLabel" [disabled]="isUneditable" #child3></county-dropdown-two-way>
			</div>
		
			<div class="row">
				<district-dropdown-two-way id="myDistrict" [reset]="resetField" [(selectedSchoolDistricts)]="chosenSchoolDistricts" [counties]="chosenCounties" [regions]="chosenRegions" (selectedSchoolDistrictsChange)="districtsSelected($event)"
					[isMultiple]="false" [customLabel]="customDistrictLabel" [disabled]="isUneditable" #child></district-dropdown-two-way>
			</div>
			<div class="row">
				<mat-form-field appearance="fill" style="background-color: transparent !important;">
					<mat-label>School District NCES *</mat-label><!-- formControlName="schoolDistrictNCES"-->
					<input id="schoolDistrictNCES" 
						[readonly]="isUneditable"  						 	
						[formControl]="schoolDistrictNcesFC"
						type="tel" 
						matInput	 
						value="{{schoolDistrictNCES}}"										
						class="form-control" 
						minlength="7" maxlength="7" 
						placeholder="NCES"
						[(ngModel)]="schoolDistrictNCES" 
						(keyup)="fnCheckNCESDistrictCode($event)"
						[errorStateMatcher]="matcher"
						(keydown)="onKeyDown($event)"
						style="background-color: transparent;"
						#child4>  
				  	    <span class="checkCodeButton">
						<ng-container *ngIf="!ncesValid && ncesChecking"> 
							<!-- including if sc is blank or invalid-->
							<button class="btnCheckRed" mat-raised-button [disabled]="isUneditable"
								(click)="btnClick.emit($event)">
								<i class="fa fa-refresh fa-spin fa-fw"></i>
							</button>
						</ng-container>
						<ng-container *ngIf="!ncesValid && !ncesChecking && !ncesChecked">
							<button class="btnCheckRed" mat-raised-button [disabled]="isUneditable"
								(click)="btnClick.emit($event)">
								<i class="fa fa-check fa-fw" style="opacity:0.3"></i>
								<!-- <mat-icon matSuffix>highlight_off</mat-icon> -->
							</button>
						</ng-container>
						<!-- <ng-container *ngIf="!ncesValid && !ncesChecking  && ncesChecked">
							<button class="btnCheckRed" mat-raised-button [disabled]="isUneditable"
								(click)="btnClick.emit($event)">
								<i class="fa fa-check fa-fw"></i>
								<mat-icon matSuffix>highlight_off</mat-icon>
							</button>
						</ng-container> -->
						<ng-container *ngIf="!ncesValid && !ncesChecking  && !ncesChecked">
							<button class="btnCheckRed" mat-raised-button [disabled]="isUneditable"
								(click)="btnClick.emit($event)">
								<i class="fa fa-check fa-fw fa-times" style="opacity:0.3"></i>
								<!-- <mat-icon matSuffix>highlight_off</mat-icon> -->
							</button>
						</ng-container>
						</span>
						<span class="checkCodeButton">
						<ng-container *ngIf="ncesValid">
							<button class="btnCheckGreen" mat-raised-button [disabled]="isUneditable"
								(click)="btnClick.emit($event)">
								<i class="fa fa-check fa-fw"></i>
								<!-- <mat-icon matSuffix>check_circle</mat-icon> -->
							</button>
						</ng-container>
					</span>
			
				</mat-form-field> 
			
				<mat-error class="moveErrorsUp"
					*ngIf="!isLoading && schoolDistrictNcesFC.hasError('required')">
					School District NCES is <strong>required</strong>
				</mat-error>
				<p>&nbsp;</p>

			</div>
		</mat-tab>
	</mat-tab-group>
	<p>&nbsp;</p>
	<!-- class="flushLeft "-->
	<div class="row">
		<div class="moveRight">
			<ng-container *ngIf="!isUneditable">
				<span styles="position:absolute;float:right;">
					<ng-container *ngIf="(saveButtonToShow == 'generalinfo')">
						<button type="button" (click)="fnSaveGeneralInfo($event);" mat-raised-button color="primary"
							[disabled]="disableCreateButton()"
							(onSubmitErrorEvent)="catchSubmitError($event)">Save</button>&nbsp;&nbsp;
					</ng-container>
					<ng-container *ngIf="(saveButtonToShow == 'contactinfo')">
						<button type="button" (click)="fnSaveContactInfo();" mat-raised-button color="primary"
							[disabled]="disableCreateButton2()"
							(onSubmitErrorEvent)="catchSubmitError($event)">Save</button>&nbsp;&nbsp;
					</ng-container>
					<ng-container *ngIf="(saveButtonToShow == 'schoollocation')">
						<button type="button" (click)="fnSaveSchoolLocation();" mat-raised-button color="primary"
							[disabled]="disableCreateButton3()"
							(onSubmitErrorEvent)="catchSubmitError($event)">Save</button>&nbsp;&nbsp;
					</ng-container>
					<mat-icon *ngIf="isLoading && !msg.SUCCESS">
						<mat-spinner *ngIf="isLoading" diameter="20"> </mat-spinner>
					</mat-icon>
					<mat-icon *ngIf="msg.SUCCESS">
						done
					</mat-icon>
					<button mat-raised-button (click)="fnReset()">Reset</button>
					&nbsp;&nbsp;
				</span>
			</ng-container>
		</div>
		<div class="errorMsg">
			<!--    class="col-8" rows="2"-->
			<textarea readonly="true" disabled class="errorMsgCtl" id="txtErrorMsg" cols="100">{{myError}}</textarea>
		</div>
		<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
			<app-msg [msg]="userIdChangedMsg" *ngIf="userIdChangedMsg.MSG"></app-msg>
			<app-msg [msg]="msg"></app-msg>
		</div>
	</div>
</form>